import { Redirect, Route, Switch } from "wouter";
import { useSession } from "./auth/use-session.js";
import { ViewScopeProvider } from "./auth/view-scope.js";
import { Nav } from "./components/nav.js";
import { Login } from "./routes/login.js";
import { Routes } from "./routes/index.js";
import { Tervetuloa } from "./routes/tervetuloa.js";

// Sovellus-shell + auth-gate.
//
// Ennen kirjautumista NAYTETAAN VAIN login-naekyma. Ei navigaatiota, ei
// otsikoita, ei mitaan muuta. Tama on perusturvaehto v1:lle: kaikki
// kratti:n kayttoliittyma vaatii autentikoitua sessiota.

export function App() {
  const session = useSession();

  // Better-Auth lataa cookie-poolin alkuvaiheessa → naytetaan minimaalinen
  // ladattaa-nakyma jotta ei flikkaa login-formin ja main-shell:in valilla.
  if (session.isPending) {
    return (
      <div className="grid min-h-screen place-items-center bg-slate-950 text-slate-500">
        Ladataan…
      </div>
    );
  }

  // Ei kirjautunut → login + /tervetuloa-julkiset polut. Kaikki muut
  // polut redirectaa login-näkymään. /tervetuloa on julkinen koska uudet
  // käyttäjät tulevat sinne invite-linkillä ennen kuin heillä on tiliä.
  if (!session.isLoggedIn) {
    return (
      <div className="min-h-screen">
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/tervetuloa" component={Tervetuloa} />
          <Route>
            <Redirect to="/login" />
          </Route>
        </Switch>
      </div>
    );
  }

  // Kirjautunut → tavallinen shell (Nav + reitit), ViewScope-context kaikkialle
  return (
    <ViewScopeProvider>
      <div className="min-h-screen">
        <Nav />
        <main>
          <Routes />
        </main>
      </div>
    </ViewScopeProvider>
  );
}
